import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'recap-solicitor-details',
    templateUrl: './recap-solicitor-details.component.html',
    styleUrls: ['./recap-solicitor-details.component.scss'],
    standalone: false
})
export class RecapSolicitorDetailsComponent implements OnInit {
    /**
      * Event emitted to tell the parent to invoke the edit action
      * 
      * @type {EventEmitter<string>}
      * @memberof RecapSolicitorDetailsComponent
      */
    @Output() stageChange: EventEmitter<string>;
    /**
     * Incoming load details data form the parent
     * 
     * @type {Object}
     * @memberof RecapSolicitorDetailsComponent
     */
    @Input() solicitorDetails: Object;
    /**
     * Flag to togle displaying the edit button
     * 
     * @type {boolean}
     * @memberof RecapSolicitorDetailsComponent
     */
    @Input() showEditButton: boolean;

    get InstructSolicitor(): string {
        return this.solicitorDetails['InstructSolicitor'];
    }

    get SolicitorName(): string {
        return this.solicitorDetails['SolicitorName'];
    }

    get Address(): string {
        return this.solicitorDetails['FullAddress'];
    }

    get LawyerName(): string {
        return this.solicitorDetails['LawyerName'];
    }

    get Phone(): string {
        return this.solicitorDetails['Phone'];
    }

    get EmailId(): string {
        return this.solicitorDetails['EmailId'];
    }
    constructor() {
        this.stageChange = new EventEmitter<string>();
    }

    ngOnInit() {
    }
    /**
     * emit stage change when edit button clicked
     * 
     * @memberof RecapLoanDetailsComponent
     */
    editButtonClicked(): void {
        this.stageChange.emit('tad_stage_solicitors_details');
    }

}
